import React from "react"

import { smoothScrollTo } from "components/utils"
import Buttons from "components/form/buttons"
import Button from "components/form/button"
import cx from "classnames"
import * as s from "./hello.module.sass"

const Hello = () => {
  const meaningful = MEANINGFUL.map((glyph) => (
    <span key={glyph.color} style={{ color: glyph.color }}>
      {glyph.letter}
    </span>
  ))
  const backgroundImage = `url("${process.env.SITE_URL}/games/ArtGalleryInside.jpg")`
  const style = {
    backgroundImage,
  }

  return (
    <div id="hello" className={s.component}>
      <div className={s.background} style={style} />

      <div className={cx("container", s.container)}>
        <div className={s.tagline}>
          We make <strong>{meaningful}</strong> games 
        </div>

        <Buttons parentClass={s.buttons}>
          <Button
            parentClass={s.button}
            color="pink"
            onClick={() => smoothScrollTo("games")}
          >
            Our Games
          </Button>

        </Buttons>
      </div>
    </div>
  )
}

const MEANINGFUL = [
  { letter: "m", color: "#EB2869" },
  { letter: "e", color: "#EB28CA" },
  { letter: "a", color: "#d998f6" },
  { letter: "n", color: "#8793ff" },
  { letter: "i", color: "#288AEB" },
  { letter: "n", color: "#27B4E5" },
  { letter: "g", color: "#26DEDE" },
  { letter: "f", color: "#28EB8A" },
  { letter: "u", color: "#99E600" },
  { letter: "l", color: "#f15e8f" },
]

export default Hello
